module.exports = __webpack_public_path__ + "img/hello.cc6f1c0b.svg";